import styled from "styled-components";

export const ChecklistFormWrapper = styled.div`
  display: none;
  @media print {
    display: block;
    padding: ${({ theme }) => theme.space.md};
    width: 100%;
    background: ${({ theme }) => theme.colors.gray300};
    border-top: 2px solid ${({ theme }) => theme.colors.gray400};
    border-bottom: 2px solid ${({ theme }) => theme.colors.gray400};
  }
`;

export const ChecklistFormSection = styled.div`
  display: flex;
  &:not(:first-child) {
    padding-top: ${({ theme }) => theme.space.md};
  }
`;

export const ChecklistFormGrade = styled.div`
  padding-left: 8.75rem;
`;

export const ChecklistFormOption = styled.span`
  position: relative;
  display: inline-block;
  width: 5rem;
  &::before {
    position: absolute;
    left: -${({ theme }) => theme.space.xl};
    top: -${({ theme }) => theme.space.sm};
    content: " ";
    width: ${({ theme }) => theme.space.lg};
    height: ${({ theme }) => theme.space.lg};
    background: ${({ theme }) => theme.colors.white};
    border: 1px solid ${({ theme }) => theme.colors.gray400};
  }
`;
